"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _style = _interopRequireDefault(require("./style.css"));
var _helpers = require("./helpers.js");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Fortress = window.cccisd && window.cccisd.fortress;
var validate = function validate(values) {
  var errors = {};
  if (!values.title) {
    errors.title = 'Title is required';
  }
  return errors;
};
var SurveyModalContents = /*#__PURE__*/function (_React$Component) {
  _inherits(SurveyModalContents, _React$Component);
  var _super = _createSuper(SurveyModalContents);
  function SurveyModalContents() {
    _classCallCheck(this, SurveyModalContents);
    return _super.apply(this, arguments);
  }
  _createClass(SurveyModalContents, [{
    key: "render",
    value: function render() {
      var assignmentProjectStr = this.props.assignmentProjectStr;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: this.props.initialValues,
        onSubmit: this.props.onSubmit,
        validate: validate,
        render: function render(_ref) {
          var handleSubmit = _ref.handleSubmit,
            isSubmitting = _ref.isSubmitting;
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, assignmentProjectStr && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].project
          }, assignmentProjectStr), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "title",
            component: _cccisdFormik.CccisdInput,
            label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
              label: "Title",
              tooltip: "This name is shown only to Quest Project Admins and not survey respondents."
            }),
            autoFocus: true
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "subtitle",
            component: _cccisdFormik.CccisdInput,
            label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
              label: "Subtitle",
              tooltip: "This description is shown only to Quest Project Admins and not survey respondents."
            })
          }), !!Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              marginBottom: '1em'
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
            title: "Advanced Settings"
          }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "isRequired",
            component: _cccisdFormik.CccisdToggle,
            label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
              label: "Required",
              tooltip: "When all required surveys are completed, the overall Quest will be marked as complete. Surveys are always played in order. Quest will still be accessible if non-required surveys are incomplete even when configured to not allow answer editing after submission."
            })
          }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
            className: "btn btn-primary",
            title: "Submit",
            isLoading: isSubmitting,
            onClick: handleSubmit
          })));
        }
      });
    }
  }]);
  return SurveyModalContents;
}(_react["default"].Component);
exports["default"] = SurveyModalContents;
_defineProperty(SurveyModalContents, "propTypes", {
  assignmentProjectStr: _propTypes["default"].string,
  closeModal: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func.isRequired,
  initialValues: _propTypes["default"].object
});